var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconBirdwatchingRegular = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 4.375C6.125 3.615 6.739 3 7.5 3h1.375c.76 0 1.375.614 1.375 1.375v.688H6.125v-.688zm-1.564 4.04a2.406 2.406 0 0 1 2.368-1.977h3.665c.571 0 1.031.46 1.031 1.03V8.5h2.75V7.469c0-.572.46-1.032 1.031-1.032h3.665c1.165 0 2.162.834 2.368 1.977l.215 1.173c.155.855.464 1.676.91 2.424l.113.189A9.304 9.304 0 0 1 24 16.973v2.87a2.408 2.408 0 0 1-2.406 2.407H16.78a2.408 2.408 0 0 1-2.406-2.406V14h-2.75v5.844a2.408 2.408 0 0 1-2.406 2.406H4.406A2.408 2.408 0 0 1 2 19.844v-2.87c0-1.685.455-3.335 1.323-4.779l.112-.189a7.236 7.236 0 0 0 .911-2.423l.215-1.173v.004zm2.368.085c-.168 0-.31.12-.34.284l-.215 1.173a9.248 9.248 0 0 1-1.169 3.115l-.111.189a7.195 7.195 0 0 0-1.032 3.712v2.87c0 .19.155.345.344.345H9.22c.189 0 .344-.155.344-.344V8.5H6.928zm12.142 0h-2.634v11.344c0 .189.155.343.344.343h4.813c.189 0 .343-.154.343-.343v-2.87a7.243 7.243 0 0 0-1.026-3.713l-.112-.19a9.313 9.313 0 0 1-1.173-3.114l-.215-1.173a.346.346 0 0 0-.34-.284zM17.125 3H18.5c.76 0 1.375.614 1.375 1.375v.688H15.75v-.688c0-.76.614-1.375 1.375-1.375z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBirdwatchingRegular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-birdwatching-regular.7aa922f6.svg";
export { ForwardRef as ReactComponent };